export const selectFilters = (state) => state.mainReducer.filters;
